import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from '@containers/App';
import PageIndexProvider from '@containers/Context/PageIndexContextProvider';
import initializeStore from '@redux/initializeStore';
import history from '@utils/history';
import { ConnectedRouter } from 'connected-react-router';

import './index.css';

const store = initializeStore();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PageIndexProvider>
        <App />
      </PageIndexProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
